import React from 'react';
import PropTypes from 'prop-types';

const LightBulb = ({ className }) => {
  return (
    <div className={className}>
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.33329 14.7155V16.6666C8.33329 17.5871 9.07946 18.3333 9.99996 18.3333C10.9205 18.3333 11.6666 17.5871 11.6666 16.6666V14.7155M9.99996 1.66663V2.49996M2.49996 9.99996H1.66663M4.58329 4.58329L4.08321 4.08321M15.4166 4.58329L15.9168 4.08321M18.3333 9.99996H17.5M15 9.99996C15 12.7614 12.7614 15 9.99996 15C7.23853 15 4.99996 12.7614 4.99996 9.99996C4.99996 7.23853 7.23853 4.99996 9.99996 4.99996C12.7614 4.99996 15 7.23853 15 9.99996Z" stroke="#323239" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
};

LightBulb.propTypes = {
  className: PropTypes.string.isRequired,
};

export default LightBulb;
